
import { defineComponent } from 'vue';

export default defineComponent({
    name:"headerComp",
    data:function()
    {
        return {}
    },
    components:{},
    props:[],
    methods:{},
    created:function(){
        console.log()
    }
})
